import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../src/assets/images/mc-logo.svg'
import _imports_1 from '../../src/assets/images/test-environment.svg'
import _imports_2 from '../../src/assets/images/prod-environment.svg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "grid-container" }
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  id: "main",
  class: "content",
  tabindex: "0",
  role: "main"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = {
  key: 0,
  class: "row lower-env"
}
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "column-container" }
const _hoisted_12 = ["aria-labelledby"]
const _hoisted_13 = {
  class: "content-column lower-env-container",
  "data-automation": "mtf-col"
}
const _hoisted_14 = { class: "top-content" }
const _hoisted_15 = ["id"]
const _hoisted_16 = { class: "button-row" }
const _hoisted_17 = ["aria-describedby", "onClick"]
const _hoisted_18 = ["id"]
const _hoisted_19 = {
  key: 1,
  class: "row higher-env"
}
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = { class: "column-container" }
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "top-content" }
const _hoisted_24 = { class: "button-row" }
const _hoisted_25 = { tabindex: "-1" }
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "top-content" }
const _hoisted_28 = { class: "button-row" }
const _hoisted_29 = { tabindex: "-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("a", {
      href: "#main",
      class: "sr-only sr-only-focusable skip-link",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollToMain($event)))
    }, "Skip to main content"),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", { href: _ctx.MCD_DASHBOARD_URL }, _toDisplayString(_ctx.$t("CONTENT.HOMEPAGE.HEADER_LINK_TEXT")), 9, _hoisted_5)
          ])
        ])
      ]),
      _createElementVNode("main", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[1] || (_cache[1] = _createElementVNode("img", {
              src: _imports_0,
              width: "100",
              height: "35",
              alt: "MC logo"
            }, null, -1)),
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t("CONTENT.HOMEPAGE.HEADING")), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("CONTENT.HOMEPAGE.DESCRIPTION")), 1)
          ])
        ]),
        (_ctx.CURRENT_ENV.VUE_APP_ENV_MODE === _ctx.LOWER_ENV)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("ul", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lowerEnvData, (env, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, [
                      _createElementVNode("section", {
                        "aria-labelledby": 'lower-env-' + index
                      }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("h2", {
                              id: 'lower-env-' + index
                            }, _toDisplayString(env.name) + " Environment ", 9, _hoisted_15),
                            _createElementVNode("p", null, [
                              _createTextVNode(" Create and manage your business profile in " + _toDisplayString(env.name) + " environment.", 1),
                              _cache[2] || (_cache[2] = _createElementVNode("br", { "aria-hidden": "true" }, null, -1)),
                              _cache[3] || (_cache[3] = _createElementVNode("br", { "aria-hidden": "true" }, null, -1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("button", {
                              "aria-describedby": 'go-to-env-' + index,
                              onClick: ($event: any) => (_ctx.redirectToEnvironment(env.link))
                            }, " Go to " + _toDisplayString(env.name), 9, _hoisted_17)
                          ]),
                          _createElementVNode("span", {
                            id: 'go-to-env-' + index,
                            class: "a11y-hidden",
                            "aria-hidden": "true"
                          }, "Click this button to go to " + _toDisplayString(env.name) + " environment", 9, _hoisted_18)
                        ])
                      ], 8, _hoisted_12)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.CURRENT_ENV.VUE_APP_ENV_MODE === _ctx.HIGHER_ENV)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("a", {
                    class: "content-column",
                    href: _ctx.MTF_URL,
                    "data-automation": "mtf-col"
                  }, [
                    _createElementVNode("div", _hoisted_23, [
                      _cache[4] || (_cache[4] = _createElementVNode("img", {
                        src: _imports_1,
                        width: "36",
                        height: "36",
                        alt: "MTF Environment image"
                      }, null, -1)),
                      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("CONTENT.HOMEPAGE.MTF.HEADING")), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t("CONTENT.HOMEPAGE.MTF.DESCRIPTION_LINE_1")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("button", _hoisted_25, _toDisplayString(_ctx.$t("CONTENT.HOMEPAGE.MTF.ACTION_TEXT")), 1)
                    ])
                  ], 8, _hoisted_22),
                  _createElementVNode("a", {
                    class: "content-column",
                    href: _ctx.PROD_URL,
                    "data-automation": "prod-col"
                  }, [
                    _createElementVNode("div", _hoisted_27, [
                      _cache[5] || (_cache[5] = _createElementVNode("img", {
                        src: _imports_2,
                        width: "36",
                        height: "36",
                        alt: "Production Environment image"
                      }, null, -1)),
                      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("CONTENT.HOMEPAGE.PROD.HEADING")), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t("CONTENT.HOMEPAGE.PROD.DESCRIPTION_LINE_1")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("button", _hoisted_29, _toDisplayString(_ctx.$t("CONTENT.HOMEPAGE.PROD.ACTION_TEXT")), 1)
                    ])
                  ], 8, _hoisted_26)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}